// extracted by mini-css-extract-plugin
export default {"header":"Home_header__i3-Ps","projectContainer":"Home_projectContainer__6OVHy","about":"Home_about__KyoKR","footer":"Home_footer__zYCXO","copyright":"Home_copyright__OaGvM"};